module.exports = __webpack_public_path__ + "img/CALENDER.6c7f2b10.svg";